(() => {
  const storageKey = 'nazva:wishlist:v1';
  let mutationFrame = null;

  const selectors = {
    toggle: '[data-nazva-wishlist-toggle]',
    header: '[data-nazva-wishlist-header]',
    headerCount: '[data-nazva-wishlist-header-count]',
    modal: '[data-nazva-wishlist-modal]',
    accountDefault: '[data-nazva-account-default]',
    accountWishlist: '[data-nazva-account-wishlist]',
    wishlistGrid: '[data-nazva-wishlist-grid]',
    wishlistEmpty: '[data-nazva-wishlist-empty]',
    wishlistSelect: '[data-nazva-wishlist-select]',
    clearSelected: '[data-nazva-wishlist-clear-selected]',
  };

  const getStrings = () => {
    const modal = document.querySelector(selectors.modal);
    const countTemplate = modal?.dataset.itemsCountTemplate || '__COUNT__ products';

    return {
      addToFavorites: modal?.dataset.addToFavorites || '',
      removeFromFavorites: modal?.dataset.removeFromFavorites || '',
      addedTitle: modal?.dataset.addedTitle || '',
      selectProduct: modal?.dataset.selectProduct || 'Select product',
      newBadge: modal?.dataset.newBadge || 'NEW',
      itemsCountTemplate: countTemplate,
      formatItemsCount(count) {
        return countTemplate.replace('__COUNT__', String(count));
      },
    };
  };

  const safeParse = (value, fallback) => {
    try {
      return JSON.parse(value) || fallback;
    } catch (error) {
      return fallback;
    }
  };

  const getWishlist = () => {
    const stored = safeParse(window.localStorage?.getItem(storageKey), {});
    return stored && typeof stored === 'object' && !Array.isArray(stored) ? stored : {};
  };

  const saveWishlist = (wishlist) => {
    window.localStorage?.setItem(storageKey, JSON.stringify(wishlist));
  };

  const toProductData = (button) => ({
    handle: button.dataset.productHandle,
    url: button.dataset.productUrl,
    title: button.dataset.productTitle,
    image: button.dataset.productImage,
    price: button.dataset.productPrice,
    compare: button.dataset.productCompare,
    salePercent: Number(button.dataset.productSalePercent || 0),
    isNew: button.dataset.productNew === 'true',
    description: button.dataset.productDescription || '',
    count: Number(button.dataset.productCount || 0),
    addedAt: Date.now(),
  });

  const escapeHtml = (value = '') =>
    String(value).replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;',
    }[char]));

  const setButtonState = (button, active, item) => {
    const strings = getStrings();
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute(
      'aria-label',
      active
        ? (button.dataset.removeLabel || strings.removeFromFavorites)
        : (button.dataset.addLabel || strings.addToFavorites)
    );

    const countElement = button.querySelector('.nazva-wishlist-button__count');
    if (countElement) {
      const baseCount = Number(button.dataset.productCount || item?.count || 0);
      countElement.textContent = `+${baseCount + (active ? 1 : 0)}`;
    }
  };

  const syncButtons = () => {
    const wishlist = getWishlist();
    document.querySelectorAll(selectors.toggle).forEach((button) => {
      const handle = button.dataset.productHandle;
      setButtonState(button, Boolean(handle && wishlist[handle]), wishlist[handle]);
    });

    const count = Object.keys(wishlist).length;
    document.querySelectorAll(selectors.header).forEach((headerLink) => {
      headerLink.classList.toggle('is-active', count > 0);
    });
    document.querySelectorAll(selectors.headerCount).forEach((countElement) => {
      countElement.hidden = count === 0;
      const inner = countElement.querySelector('span');
      if (inner) inner.textContent = count > 99 ? '99+' : String(count);
    });
  };

  const openModal = (item) => {
    const modal = document.querySelector(selectors.modal);
    if (!modal) return;

    const strings = getStrings();
    const image = modal.querySelector('[data-nazva-wishlist-modal-image]');
    const title = modal.querySelector('[data-nazva-wishlist-modal-title]');
    const price = modal.querySelector('[data-nazva-wishlist-modal-price]');
    const compare = modal.querySelector('[data-nazva-wishlist-modal-compare]');
    const sale = modal.querySelector('[data-nazva-wishlist-modal-sale]');
    const modalTitle = modal.querySelector('#NazvaWishlistModalTitle');

    if (image) {
      image.src = item.image || '';
      image.alt = item.title || '';
      image.closest('.nazva-wishlist-modal__image-wrap').hidden = !item.image;
    }
    if (modalTitle && strings.addedTitle) modalTitle.textContent = strings.addedTitle;
    if (title) title.textContent = item.title || '';
    if (price) price.textContent = item.price || '';
    if (compare) {
      compare.textContent = item.compare || '';
      compare.hidden = !item.compare;
    }
    if (sale) {
      sale.textContent = item.salePercent > 0 ? `-${item.salePercent}%` : '';
      sale.hidden = item.salePercent <= 0;
    }

    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('nazva-wishlist-modal-open');
    requestAnimationFrame(() => modal.classList.add('is-open'));
    modal.querySelector('.nazva-wishlist-modal__dialog')?.focus();
  };

  const closeModal = () => {
    const modal = document.querySelector(selectors.modal);
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('nazva-wishlist-modal-open');
    window.setTimeout(() => {
      if (!modal.classList.contains('is-open')) modal.hidden = true;
    }, 180);
  };

  const toggleWishlist = (button) => {
    const item = toProductData(button);
    if (!item.handle) return;

    const wishlist = getWishlist();
    const wasActive = Boolean(wishlist[item.handle]);

    if (wasActive) {
      delete wishlist[item.handle];
    } else {
      wishlist[item.handle] = item;
    }

    saveWishlist(wishlist);
    syncButtons();
    renderAccountWishlist();

    if (!wasActive) openModal(item);
  };

  const syncWishlistSelectionControls = () => {
    document.querySelectorAll(selectors.accountWishlist).forEach((section) => {
      const selected = section.querySelectorAll(`${selectors.wishlistSelect}:checked`);
      const clearButton = section.querySelector(selectors.clearSelected);
      if (clearButton) clearButton.hidden = selected.length === 0;
    });
  };

  const clearSelectedWishlistItems = (button) => {
    const section = button.closest(selectors.accountWishlist);
    if (!section) return;

    const selectedHandles = [...section.querySelectorAll(`${selectors.wishlistSelect}:checked`)]
      .map((input) => input.dataset.nazvaWishlistSelect)
      .filter(Boolean);

    if (!selectedHandles.length) return;

    const wishlist = getWishlist();
    selectedHandles.forEach((handle) => {
      delete wishlist[handle];
    });

    saveWishlist(wishlist);
    renderAccountWishlist();
    syncButtons();
  };

  const productCardMarkup = (item) => {
    const strings = getStrings();
    const saleBadge = item.salePercent > 0
      ? `<span class="nazva-product-sticker nazva-product-sticker--sale">-${item.salePercent}%</span>`
      : '';
    const newBadge = item.isNew
      ? `<span class="nazva-product-sticker nazva-product-sticker--new">${escapeHtml(strings.newBadge)}</span>`
      : '';
    const compare = item.compare ? `<s>${escapeHtml(item.compare)}</s>` : '';

    return `
      <article class="nazva-wishlist-card" data-nazva-wishlist-item="${escapeHtml(item.handle)}">
        <label class="nazva-wishlist-card__select" aria-label="${escapeHtml(strings.selectProduct)}">
          <input type="checkbox" data-nazva-wishlist-select="${escapeHtml(item.handle)}">
          <span aria-hidden="true"></span>
        </label>
        <a class="nazva-wishlist-card__image-link" href="${escapeHtml(item.url || '#')}">
          <div class="nazva-wishlist-card__badges">${newBadge}${saleBadge}</div>
          ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">` : ''}
        </a>
        <div class="nazva-wishlist-card__content">
          <h3><a href="${escapeHtml(item.url || '#')}">${escapeHtml(item.title)}</a></h3>
          <p>${escapeHtml(item.description || '')}</p>
          <div class="nazva-wishlist-card__price">
            <span>${escapeHtml(item.price || '')}</span>
            ${compare}
          </div>
        </div>
      </article>
    `;
  };

  const renderAccountWishlist = () => {
    const wishlistSection = document.querySelector(selectors.accountWishlist);
    const grid = document.querySelector(selectors.wishlistGrid);
    if (!wishlistSection || !grid) return;

    const wishlist = getWishlist();
    const items = Object.values(wishlist).sort((a, b) => (b.addedAt || 0) - (a.addedAt || 0));
    const empty = document.querySelector(selectors.wishlistEmpty);
    const count = document.querySelector('[data-nazva-wishlist-account-count]');

    grid.innerHTML = items.map(productCardMarkup).join('');
    grid.hidden = items.length === 0;
    if (empty) empty.hidden = items.length > 0;
    if (count) count.textContent = items.length ? getStrings().formatItemsCount(items.length) : '';
    syncWishlistSelectionControls();
  };

  const showAccountView = () => {
    const wishlistSection = document.querySelector(selectors.accountWishlist);
    const defaultSection = document.querySelector(selectors.accountDefault);
    if (!wishlistSection) return;

    const isStandalone = wishlistSection.hasAttribute('data-nazva-wishlist-standalone');
    const params = new URLSearchParams(window.location.search);
    const showWishlist = isStandalone || params.get('view') === 'wishlist' || window.location.hash === '#wishlist';

    wishlistSection.hidden = !showWishlist;
    if (defaultSection) defaultSection.hidden = showWishlist;
    document.querySelector('[data-nazva-account-wishlist-link]')?.classList.toggle('is-active', showWishlist);
    document.querySelector('[data-nazva-account-orders-link]')?.classList.toggle('is-active', !showWishlist);
    if (showWishlist) renderAccountWishlist();
  };

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-nazva-wishlist-close]');
    if (closeButton) {
      event.preventDefault();
      closeModal();
      return;
    }

    const removeButton = event.target.closest('[data-nazva-wishlist-remove]');
    if (removeButton) {
      event.preventDefault();
      const wishlist = getWishlist();
      delete wishlist[removeButton.dataset.nazvaWishlistRemove];
      saveWishlist(wishlist);
      renderAccountWishlist();
      syncButtons();
      return;
    }

    const clearSelectedButton = event.target.closest(selectors.clearSelected);
    if (clearSelectedButton) {
      event.preventDefault();
      clearSelectedWishlistItems(clearSelectedButton);
      return;
    }

    const toggle = event.target.closest(selectors.toggle);
    if (!toggle) return;

    event.preventDefault();
    event.stopPropagation();
    toggleWishlist(toggle);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeModal();
  });

  document.addEventListener('change', (event) => {
    if (!event.target.closest(selectors.wishlistSelect)) return;
    syncWishlistSelectionControls();
  });

  window.addEventListener('popstate', showAccountView);
  document.addEventListener('shopify:section:load', () => {
    syncButtons();
    showAccountView();
  });

  const observer = new MutationObserver(() => {
    if (mutationFrame) return;
    mutationFrame = window.requestAnimationFrame(() => {
      mutationFrame = null;
      syncButtons();
    });
  });

  document.addEventListener('DOMContentLoaded', () => {
    syncButtons();
    showAccountView();
    renderAccountWishlist();
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
